export const titles = [
    "Mr",
    "Mrs",
    "Miss",
    "Ms",
    "Dr",
    "Prof",
];
